function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProgressi = function SvgProgressi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M5.438 19.264c-2.29 0-4.16-1.862-4.16-4.155s1.87-4.155 4.16-4.155h1.5a.7.7 0 1 1 0 1.4h-1.5a2.76 2.76 0 0 0-2.76 2.755c0 1.52 1.24 2.755 2.76 2.755h14.42l-1.09-.814a.7.7 0 1 1 .84-1.122l2.77 2.07c.18.132.28.339.28.559a.71.71 0 0 1-.27.561l-2.77 2.08a.7.7 0 0 1-.98-.139.7.7 0 0 1 .14-.98l1.08-.815zm2.22-13.82a3.224 3.224 0 0 1-3.14 2.518 3.22 3.22 0 0 1-3.22-3.218 3.22 3.22 0 0 1 3.22-3.219c1.53 0 2.82 1.079 3.14 2.519h10.93a4.156 4.156 0 0 1 0 8.309l-.02.001h-1.48a.7.7 0 1 1 0-1.4h1.48a2.756 2.756 0 0 0 0-5.51H7.658m-3.14-2.519c-1.01 0-1.82.815-1.82 1.819s.81 1.818 1.82 1.818c1 0 1.82-.815 1.82-1.818s-.82-1.819-1.82-1.819m6.11 9.429a.7.7 0 1 1 0-1.4h2.65c.38 0 .7.313.7.7s-.32.7-.7.7z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProgressi);
export default ForwardRef;